const MediaGallery = () => {
  const images = [
    {
      id: 1,
      url: 'https://public.readdy.ai/ai/img_res/451ce68368c89d516684ab3085e8343d.jpg',
      title: 'Spezie Colorate',
      category: 'Prodotti'
    },
    {
      id: 2,
      url: 'https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20organic%20cookies%20arranged%20artistically%20with%20herbal%20tea%20and%20natural%20ingredients%20on%20rustic%20wooden%20table%2C%20warm%20natural%20lighting%20with%20soft%20shadows%2C%20minimalist%20food%20styling%20with%20earthy%20tones&width=800&height=600&seq=gallery2&orientation=landscape',
      title: 'Momento del Tè',
      category: 'Lifestyle'
    },
    {
      id: 3,
      url: 'https://readdy.ai/api/search-image?query=extreme%20close%20up%20macro%20shot%20of%20organic%20cinnamon%20sticks%20showing%20detailed%20texture%20and%20natural%20patterns%2C%20soft%20natural%20lighting%20with%20shallow%20depth%20of%20field%2C%20artistic%20food%20photography%20with%20warm%20brown%20tones&width=600&height=800&seq=gallery3&orientation=portrait',
      title: 'Texture Naturali',
      category: 'Dettagli'
    },
    {
      id: 4,
      url: 'https://readdy.ai/api/search-image?query=farmer%20harvesting%20fresh%20organic%20turmeric%20roots%20from%20rich%20soil%20in%20sunlit%20field%2C%20warm%20golden%20hour%20lighting%20with%20authentic%20agricultural%20scene%2C%20documentary%20style%20photography%20with%20earthy%20tones&width=800&height=600&seq=gallery4&orientation=landscape',
      title: 'Raccolta Biologica',
      category: 'Processo'
    },
    {
      id: 5,
      url: 'https://readdy.ai/api/search-image?query=elegant%20glass%20jars%20with%20organic%20spices%20arranged%20on%20white%20marble%20surface%20with%20natural%20window%20lighting%2C%20minimalist%20product%20photography%20with%20clean%20composition%20and%20premium%20styling&width=600&height=800&seq=gallery5&orientation=portrait',
      title: 'Collezione Premium',
      category: 'Prodotti'
    },
    {
      id: 6,
      url: 'https://readdy.ai/api/search-image?query=artisan%20cookies%20on%20ceramic%20plate%20with%20steam%20rising%20from%20tea%20cup%2C%20warm%20cozy%20lighting%20with%20rustic%20ambiance%2C%20lifestyle%20food%20photography%20with%20authentic%20moment%20and%20natural%20tones&width=800&height=600&seq=gallery6&orientation=landscape',
      title: 'Pausa Relax',
      category: 'Lifestyle'
    },
    {
      id: 7,
      url: 'https://readdy.ai/api/search-image?query=hands%20pouring%20golden%20turmeric%20powder%20from%20wooden%20spoon%20with%20dust%20particles%20in%20air%2C%20dramatic%20natural%20lighting%20with%20shallow%20focus%2C%20artistic%20food%20photography%20with%20warm%20golden%20tones&width=600&height=800&seq=gallery7&orientation=portrait',
      title: 'Curcuma Dorata',
      category: 'Dettagli'
    },
    {
      id: 8,
      url: 'https://readdy.ai/api/search-image?query=organic%20farm%20landscape%20at%20sunrise%20with%20green%20fields%20and%20natural%20beauty%2C%20wide%20angle%20shot%20with%20warm%20morning%20light%2C%20documentary%20style%20photography%20with%20peaceful%20agricultural%20scene&width=800&height=600&seq=gallery8&orientation=landscape',
      title: 'I Nostri Campi',
      category: 'Processo'
    }
  ];

  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-[#2D5016] mb-4">
            Galleria Fotografica
          </h2>
          <p className="text-gray-600 text-lg">
            Immagini che raccontano la nostra passione per la qualità
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {images.map((image) => (
            <div
              key={image.id}
              className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
              style={{ height: image.id % 3 === 0 ? '400px' : '320px' }}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-white text-xs font-medium mb-2">
                    {image.category}
                  </span>
                  <h3 className="text-white text-xl font-semibold">
                    {image.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Vuoi vedere più contenuti? Seguici sui social media
          </p>
          <div className="flex items-center justify-center space-x-4">
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center bg-[#2D5016] rounded-full hover:bg-[#3d6b1e] transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-white text-xl"></i>
            </a>
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center bg-[#2D5016] rounded-full hover:bg-[#3d6b1e] transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-white text-xl"></i>
            </a>
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center bg-[#2D5016] rounded-full hover:bg-[#3d6b1e] transition-colors cursor-pointer"
            >
              <i className="ri-pinterest-line text-white text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaGallery;